<template>
  <HistoryChangeTable
    endpoint="v2/discount-histories"
    :base-params="{ discountProgramId }"
    :action-options="actionOptions"
    :no-change-text="messages.NO_CHANGE"
    :no-match-text="messages.NO_MATCH"
    :invalid-date-range-text="messages.INVALID_DATE_RANGE"
    :on-error="onError"
    @show-detail="showDetail"
  >
    <DiscountProgramHistoryDetail ref="history-detail" />
  </HistoryChangeTable>
</template>

<script>
import {
  COUPON_HISTORY_ACTION_OPTIONS,
  DISCOUNT_HISTORY_MESSAGES,
} from '@/utils/constants';
import HistoryChangeTable from '@/view/components/history/HistoryChangeTable.vue';
import { toastHistoryError } from '@/view/components/history/history-error';
import DiscountProgramHistoryDetail from '@/view/components/discount-program/DiscountProgramHistoryDetail.vue';

export default {
  name: 'DiscountChangeHistoryTable',
  components: { HistoryChangeTable, DiscountProgramHistoryDetail },
  props: {
    discountProgramId: { type: [Number, String], required: true },
  },
  data() {
    return {
      actionOptions: COUPON_HISTORY_ACTION_OPTIONS,
      messages: DISCOUNT_HISTORY_MESSAGES,
    };
  },
  methods: {
    onError(error) {
      toastHistoryError(
        error,
        this.messages.FORBIDDEN,
        this.messages.LOAD_FAILED,
      );
    },
    showDetail(item) {
      this.$refs['history-detail'].show(item.id);
    },
  },
};
</script>
